import ClientHeader from "@/client/pages/categories/ClientHeader";

const ClientWrapper = ({ children }) => {
  return (
    <div className="bg-[#E7EEF6] min-h-screen">
      <ClientHeader />
      <main className="container mx-auto p-4">{children}</main>
    </div>
  );
};

export default ClientWrapper;
